<template>
  <router-view />
</template>
<script>

import { directLogin } from './service';
import { clearStorage, getTipoUsuario } from '@/modules/shared/storage';

export default {
  async beforeCreate() {
    clearStorage();

    const [token, refreshToken, nome, email] = this.$route.params.params.toString().split('&');

    const parametros = {
      token,
      refreshToken,
      nome,
      email,
    };

    directLogin(parametros);

    const tipoUsuario = getTipoUsuario();
    const config = this.$router.rotasUsuarios?.[tipoUsuario];

    if (config) {
      config.routes.forEach((route) => this.$router.addRoute(route));
      this.$router.addRoute({
        path: '/:catchAll(.*)',
        name: 'catchAll',
        redirect: config.redirect,
      });

      this.$router.replace(config.redirect);
    } else {
      this.$router.replace('/');
    }
  },
};
</script>
